import AboutSection from "../components/AboutSection/AboutSection";

export default function About(){
    return(
        <AboutSection/>
    )
}